import { create } from "zustand/react";
import dayjs from "dayjs";
import { InspectionListFilters } from "@/types";

/** Rows per page the inspections list opens with. */
export const INSPECTIONS_PAGE_SIZE = 15;

type InspectionsState = {
  from: Date | null;
  setFrom: (from: Date | null) => void;
  to: Date | null;
  setTo: (to: Date | null) => void;
  supplierCompanyId: number | null;
  setSupplierCompanyId: (supplierCompanyId: number | null) => void;
  salesItemId: number | null;
  setSalesItemId: (salesItemId: number | null) => void;
  currentPage: number;
  setPage: (page: number) => void;
  rowsPerPage: number;
  setRowsPerPage: (rowsPerPage: number) => void;
};

// Like the orders list, changing a filter or the page size goes back to the first page.
export const useInspectionsStore = create<InspectionsState>((set) => ({
  from: null,
  setFrom: (from) => set({ from, currentPage: 1 }),
  to: null,
  setTo: (to) => set({ to, currentPage: 1 }),
  supplierCompanyId: null,
  setSupplierCompanyId: (supplierCompanyId) => set({ supplierCompanyId, currentPage: 1 }),
  salesItemId: null,
  setSalesItemId: (salesItemId) => set({ salesItemId, currentPage: 1 }),
  currentPage: 1,
  setPage: (page) => set({ currentPage: page }),
  rowsPerPage: INSPECTIONS_PAGE_SIZE,
  setRowsPerPage: (rowsPerPage) => set({ rowsPerPage, currentPage: 1 }),
}));

/** The filters as the list endpoint takes them: dates as `yyyy-MM-dd`, unset ones left out. */
export const useInspectionListFilters = (): InspectionListFilters => {
  const from = useInspectionsStore((s) => s.from);
  const to = useInspectionsStore((s) => s.to);
  const supplierCompanyId = useInspectionsStore((s) => s.supplierCompanyId);
  const salesItemId = useInspectionsStore((s) => s.salesItemId);

  return {
    ...(from ? { from: dayjs(from).format("YYYY-MM-DD") } : {}),
    ...(to ? { to: dayjs(to).format("YYYY-MM-DD") } : {}),
    ...(supplierCompanyId ? { supplierCompanyId } : {}),
    ...(salesItemId ? { salesItemId } : {}),
  };
};
